import React, { PureComponent } from 'react';
import styled, { withTheme } from "styled-components";
import Sizes from "../Assets/Sizes";
import Plus from '@material-ui/icons/Add';
import Minus from '@material-ui/icons/Remove';


const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    direction: ltr;
    height: 0;
`;

const VolumeButton = styled.div`
  border: 1px solid black;
  color: ${ props => `${ props.theme.colors.safeText }` };
  border: ${ props => `2px solid ${ props.theme.colors.safeText }` };
  height: ${ Sizes.footerPoweredByMinHeight };
  width: ${ Sizes.footerPoweredByMinHeight };
  padding: 0 ${ Sizes.smallMargin };
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

const VolumeText = styled.div`
  color: ${ props => `${ props.theme.colors.safeText }` };
  padding: 0 ${ Sizes.mediumPadding };
`;


class QuantityPicker extends PureComponent {

	changeQuantity = (add, event) => {
		event.stopPropagation();
		event.preventDefault();
		this.props.changeQuantity(add);
	}

	render() {
		return <Wrapper>
			<VolumeButton onClick={ (ev) => this.changeQuantity(false, ev) }><Minus/></VolumeButton>
			<VolumeText>{ this.props.quantity }</VolumeText>
			<VolumeButton onClick={ (ev) => this.changeQuantity(true, ev) }><Plus/></VolumeButton>

		</Wrapper>
	}
}

export default withTheme(QuantityPicker)
